/**
 * feifan-xxl-portal 网关请求（组织树、设计师任务等）
 */

import { getAuthHeaders } from '@/utils/authToken';
import {
  HttpError,
  createHttpError,
  notifyHttpError,
} from '@/services/httpErrorHandler';

const PORTAL_BASE_URL = (
  import.meta.env.VITE_PORTAL_API_BASE_URL ||
  (import.meta.env.VITE_API_BASE_URL
    ? import.meta.env.VITE_API_BASE_URL.replace(/feifan-xxl-art$/, 'feifan-xxl-portal').replace(/\/$/, '')
    : 'https://xxl-gateway.1605ai.com/feifan-xxl-portal')
).replace(/\/$/, '');
const pendingPortalGetRequests = new Map();

function appendParams(url, params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (key === 'orders' && Array.isArray(value)) {
      value.forEach((order, index) => {
        search.set(`orders[${index}].column`, order.column);
        search.set(`orders[${index}].asc`, String(order.asc));
      });
      return;
    }
    search.set(key, Array.isArray(value) ? value.join(',') : String(value));
  });
  const query = search.toString();
  return query ? `${url}?${query}` : url;
}

function rejectPortalError(error, { silentError, url }) {
  notifyHttpError(error, { silent: silentError, url });
  throw error;
}

export async function portalRequest(path, options = {}) {
  const { params, body, headers, silentError = false, baseURL, ...rest } = options;
  const isFormData = body instanceof FormData;
  const baseUrl = (baseURL || PORTAL_BASE_URL).replace(/\/$/, '');
  const requestUrl = appendParams(`${baseUrl}${path}`, params);
  const requestHeaders = getAuthHeaders({
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...headers,
  });
  const config = {
    ...rest,
    headers: requestHeaders,
    body: body && !isFormData ? JSON.stringify(body) : body,
  };
  const method = String(config.method || 'GET').toUpperCase();
  const requestKey = `${method}:${requestUrl}:${requestHeaders.Authorization || ''}`;
  if (method === 'GET' && !config.signal && pendingPortalGetRequests.has(requestKey)) {
    return pendingPortalGetRequests.get(requestKey);
  }

  const task = (async () => {
    try {
      const response = await fetch(requestUrl, config);
      const payload = await response.json().catch(() => ({}));

      if (!response.ok || payload.success === false) {
        rejectPortalError(createHttpError(payload, response, requestUrl), { silentError, url: requestUrl });
      }

      return payload;
    } catch (error) {
      if (error instanceof HttpError) throw error;

      const networkError = new HttpError(error?.message || '网络请求失败，请检查网络连接', {
        url: requestUrl,
      });
      rejectPortalError(networkError, { silentError, url: requestUrl });
    }
  })();

  if (method !== 'GET' || config.signal) return task;
  pendingPortalGetRequests.set(requestKey, task);
  try {
    return await task;
  } finally {
    if (pendingPortalGetRequests.get(requestKey) === task) pendingPortalGetRequests.delete(requestKey);
  }
}
